import { PropsWithChildren, ReactElement } from "react";
import { Menu, MenuList, MenuProps, Portal } from "@chakra-ui/react";

export interface IContextMenuProps extends MenuProps {
    items: ReadonlyArray<ReactElement>;
    shouldWrapInPortal?: boolean;
}

interface IPortalWrap {
    shouldWrapInPortal: boolean;
}

const PortalWrap = ({ shouldWrapInPortal, children }: PropsWithChildren<IPortalWrap>) => {
    if (shouldWrapInPortal) {
        return <Portal>{children}</Portal>;
    }

    return <>{children}</>;
};

export const ContextMenu = ({ items, children, shouldWrapInPortal = false, ...passedProps }: IContextMenuProps) => (
    <Menu variant="contextMenu" isLazy {...passedProps} autoSelect={false}>
        <>
            {children}
            <PortalWrap shouldWrapInPortal={shouldWrapInPortal}>
                <MenuList zIndex="dropdown">{items}</MenuList>
            </PortalWrap>
        </>
    </Menu>
);
